import { render, staticRenderFns } from "./SvgHeart.vue?vue&type=template&id=a8585fd4&"
import script from "./SvgHeart.vue?vue&type=script&lang=js&"
export * from "./SvgHeart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports